import React, { useState, useEffect } from 'react';
import Login from './Login';
import OwnerPage from './OwnerPage';
import axios from 'axios';

const OwnerHome = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('ownerToken'));
  const [token, setToken] = useState(localStorage.getItem('ownerToken'));
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      if (isLoggedIn && token) {
        try {
          const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/auth/profile`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setProfile(response.data.profile);
        } catch (error) {
          console.error('Profile retrieval failed:', error);
          handleLogout();
        }
      }
    };
    
    if (isLoggedIn && token) {
      fetchProfile();
    }
  }, [isLoggedIn, token]);

  const handleLogin = (newToken) => {
    if (newToken) {
      // Clear any existing retailer session
      localStorage.removeItem('retailerToken');
      
      // Set owner session
      setToken(newToken);
      setIsLoggedIn(true);
      localStorage.setItem('ownerToken', newToken);
      console.log('Owner logged in, Retailer session cleared');
    } else {
      console.error('Invalid token');
    }
  };

  const handleLogout = () => {
    setToken(null);
    setIsLoggedIn(false);
    setProfile(null);
    localStorage.removeItem('ownerToken');
    console.log('Logged out');
  };

  return (
    <div className="Container_Home">
      {isLoggedIn ? (
        profile ? (
          <OwnerPage profile={profile} isLoggedIn={isLoggedIn} onLogout={handleLogout} />
        ) : (
          <button className="logout" onClick={handleLogout}>Logout</button>
        )
      ) : (
        <Login onLogin={handleLogin} />
      )}
    </div>
  );
};

export default OwnerHome;
